import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType, CommonRoutes,
} from 'app/enums/common.enums'
import {
    IndustryType,
} from 'app/enums/label.enums'
import {
    Company,
} from './Companies.types'

const config: SkyNetTableConfig<keyof Company> = {
    name: 'Company',
    tabs: [{
        name: 'All Companies',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'companyName',
                reduced: true,
            },
            {
                name: 'hasAccount',
                labelKey: 'Company.hasAccount',
                componentName: 'ChipCheckMark',
            },
            {
                name: 'website',
                reduced: true,
            },
            {
                name: 'industryType',
                labelKey: 'ContactBase.type',
                componentName: 'EnumValue',
                filterField: 'industryType',
                allowedValuesEnum: IndustryType,
                filterType: FilterType.Array,
            },
            {
                name: 'createdBy',
                reduced: true,
                labelKey: 'CompanyView.createdBy',
            },
        ],
    }],
}

export default config
